var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mobileAgree"},[_c('div',{staticClass:"text_content"},[_c('h3',[_vm._v("隐私政策")]),_c('div',{staticClass:"mobile-agree-content"},_vm._l((_vm.formattedContent('privacyContent')),function(item,i){return _c('p',{key:i},[_vm._v(" "+_vm._s(item)+" ")])}),0)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }